import * as React from 'react'

function SvgAsset42(props) {
  return (
    <svg viewBox="0 0 220 219.25" {...props}>
      <g data-name="Layer 2">
        <path
          d="M0 0l.75 218.5 109.63-109.63zm220 0v219.25A109.63 109.63 0 01220 0z"
          fillRule="evenodd"
          data-name="Layer 1"
        />
      </g>
    </svg>
  )
}

export default SvgAsset42
